
import { computed, defineComponent } from 'vue'

// Icons
import Logo from '@/assets/images/white_full_logo.svg'

export default defineComponent({
	name: 'PaymentMethodHeader',

	setup() {
		const logoIcon = computed(() => Logo)

		return {
			logoIcon
		}
	}
})
